import React, { useState, useEffect, useRef } from 'react';
import Features from '../Features/features';
import About from '../About/about';
import './home.css';
import Contact from '../Contact/contact';

// Replace these with your actual app screenshot / promo images
import img1 from '../assets/pfp.PNG';
import img2 from '../assets/maps.PNG';
import img3 from '../assets/lost.PNG';
import img4 from '../assets/found.PNG';
// import img5 from '../assets/comment.PNG';
import img6 from '../assets/foundmap.PNG';
import img7 from '../assets/matchFound.PNG';
import img8 from '../assets/protected.PNG';
import img9 from '../assets/createPet.PNG';

const images = [
    { src: img1, alt: 'Users Profile Page' },
    { src: img9, alt: 'Create Pet' },
    { src: img8, alt: 'Pet is protected screen' },
    { src: img3, alt: 'Marking pet as lost' },
    // { src: img5, alt: 'comment page' },
  { src: img2, alt: 'Map View' },
  { src: img7, alt: 'Pet match found' },
  { src: img6, alt: 'Pet pinned on map' },
  { src: img4, alt: 'Marking pet as found' },
];

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  useEffect(() => {
    resetTimer();
    timeoutRef.current = setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3500);

    return () => resetTimer();
  }, [currentIndex]);

  return (
    <>
      <div className="appBody">
        <div className="homeContainer">
          <div className="text">
            <h1>Scan. Match. Reunite.</h1>
            <h3>
              TailTrace uses AI powered photo scanning to match lost pets with
              found ones in your area. Helping families reunite faster than ever.
            </h3>
            <div className="homeStats">
              <div className="statItem">
                <span className="statIcon">📍</span>
                <span className="statLabel">Location Based Alerts</span>
              </div>
              <div className="statItem">
                <span className="statIcon">🔍</span>
                <span className="statLabel">AI Scan Matching</span>
              </div>
              <div className="statItem">
                <span className="statIcon">🐾</span>
                <span className="statLabel">Community Powered</span>
              </div>
            </div>
          </div>

          <div className="carouselWrapper">
            <div className="carouselViewport">
              {images.map((image, index) => (
                <img
                  key={index}
                  src={image.src}
                  alt={image.alt}
                  className={`carouselImage ${index === currentIndex ? 'active' : ''}`}
                />
              ))}
            </div>
            <div className="carouselDots">
              {images.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentIndex ? 'activeDot' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <Features />
      <About />
      <Contact />
    </>
  );
};

export default Home;